// Constants extracted from ResourceBankModule.js

// Constants
export const NAME = "resources";
export const INITIALISE_RESOURCEBANK_COMPONENT =
  "INITIALISE_RESOURCEBANK_COMPONENT" + " " + NAME;
export const UPDATE_RESOURCEBANK_FILTERS =
  "UPDATE_RESOURCEBANK_FILTERS" + " " + NAME;
export const TOGGLE_RESOURCEBANK_FILTER_ITEM =
  "TOGGLE_RESOURCEBANK_FILTER_ITEM" + " " + NAME;
export const TOGGLE_ALL_RESOURCEBANK_FILTER_ITEMS =
  "TOGGLE_ALL_RESOURCE_FILTER_ITEMS" + " " + NAME;
export const TOGGLE_RESOURCEBANK_SELECTED_RESOURCES =
  "TOGGLE_RESOURCEBANK_SELECTED_RESOURCES" + " " + NAME;
export const CLEAR_RESOURCEBANK_SELECTED_RESOURCES =
  "CLEAR_RESOURCEBANK_SELECTED_RESOURCES" + " " + NAME;
